import { Badge, Box, Flex, Title, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TextSerif } from "../../TextSerif";
import classes from "../styles/PlansCard.module.css";

import { usePlansUser } from "@/services/plans/get-user-plan";

import type { FC } from "react";

interface HeaderProps {
  title: string;
  description: string;
}

export const Header: FC<HeaderProps> = ({ title, description }) => {
  const { t } = useTranslation();
  const { data: plans } = usePlansUser();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  const descriptionColor = isDark ? "secondary.1" : "secondary.6";

  if (title === "" || description === "" || !title || !description) return;

  return (
    <>
      {/* Header */}
      <Box className={classes.header}>
        <Flex justify="start" align="center" gap="md">
          <Title fz="h3" mb={12} style={{ lineHeight: 1 }}>
            {title}
          </Title>
          {title.toLowerCase() === plans?.name.toLowerCase() && (
            <Badge bg="primary" c="white" size="lg" pos="relative" bottom={4} left={4}>
              {t("plans.yourPlan")}
            </Badge>
          )}
        </Flex>
        <TextSerif m={0} mb="sm" fz="sm" fw="normal" c={descriptionColor}>
          {description}
        </TextSerif>
      </Box>
    </>
  );
};
